import { P2GBox, P2GGrid } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ToUniqueExtrasList } from '~/apps/smartsend/lib/helpers/ToUniqueExtras';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import ItemExtrasToggle from './ItemExtrasToggle';
import { EditType } from './EditType';

interface props {
  edit: (editType: EditType) => void;
  item: SmartSendItemApiModel;
  revealText?: string;
  variant?: 'body2' | 'body1';
}

export function ItemExtrasMobile(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <>
      <P2GGrid container gap={1} alignItems="center" wrap="nowrap">
        <P2GGrid item flexGrow={1}>
          <P2GText variant={props.variant}>
            {ToUniqueExtrasList(t, props.item.Extras) || t('SERVICE_EXTRAS', 'Service extras and protection')}
          </P2GText>
        </P2GGrid>
        <P2GGrid item flexShrink={1}>
          <P2GLink variant={props.variant} onClick={() => props.edit('EXTRAS')}>
            {props.revealText || t('EDIT_LINK', 'Edit')}
          </P2GLink>
        </P2GGrid>
      </P2GGrid>
      <P2GBox py={2}>
        <ItemExtrasToggle item={props.item} edit={props.edit} isMobile={true} />
      </P2GBox>
    </>
  );
}
